export type PermitApplicationTask = {
  id: number;
  permit_application_id: number;
  user_id: number;
  title: string;
  due_at: string | null;
  completed_at: string | null;
  position: number;
  created_at: string;
  updated_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

export async function listPermitApplicationTasks(
  municipalityId: number,
  applicationId: number,
): Promise<PermitApplicationTask[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/tasks`,
    { credentials: "include", headers: { Accept: "application/json" } },
  );
  if (!response.ok) throw new Error("Failed to load tasks");
  return response.json();
}

export async function createPermitApplicationTask(
  municipalityId: number,
  applicationId: number,
  payload: { title: string; due_at?: string | null },
): Promise<PermitApplicationTask> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/tasks`,
    {
      method: "POST",
      credentials: "include",
      headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
      body: JSON.stringify({ permit_application_task: payload }),
    },
  );
  if (!response.ok) throw new Error("Failed to create task");
  return response.json();
}

export async function updatePermitApplicationTask(
  municipalityId: number,
  applicationId: number,
  taskId: number,
  payload: Partial<{ title: string; due_at: string | null; completed_at: string | null }>,
): Promise<PermitApplicationTask> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/tasks/${taskId}`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
      body: JSON.stringify({ permit_application_task: payload }),
    },
  );
  if (!response.ok) throw new Error("Failed to update task");
  return response.json();
}

export async function deletePermitApplicationTask(
  municipalityId: number,
  applicationId: number,
  taskId: number,
): Promise<void> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/tasks/${taskId}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: { "X-CSRF-Token": csrfToken() },
    },
  );
  if (!response.ok) throw new Error("Failed to delete task");
}
